import { IPaymentFrequency } from 'typescript/interfaces/paymentFrequency'

export const paymentFrequency: IPaymentFrequency[] = ['Daily', 'Weekly', 'Biweekly', 'Customised']
